<template>
  <div class="rhcn-steps">
    <el-steps :active="active">
      <template v-for="(item, index) in steps">
        <el-step icon="el-icon-edit" :key="index">
          <template slot="title">
            <span class="rhcn-step-title" >{{$t(item.title)}}</span>
            <span class="rhcn-step-click-btn" @click="clickHandler.call(this, item)">{{$t(item.title)}}</span>
          </template>
          <template slot="icon">
            <span class="rhcn-dot"></span>
          </template>
        </el-step>
      </template>
    </el-steps>
  </div>
</template>
<script>
export default {
  name: 'rhcn-step',
  props: {
    active: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    clickHandler(item) {
      if (item.handler) {
        item.handler(item);
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.rhcn-steps {
  width: 100%;
  padding-left: 27px;
  padding-right: 27px;
  padding-bottom: 20px;
  box-sizing: border-box;
  .rhcn-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: $color-text-primary;
  }
  .el-step__icon {
    top: 1px;
  }
  .el-step__icon.is-icon {
    background: transparent;
    width: 9px;
    height: auto;
  }
  .el-steps {
    .el-step {
      &:first-child {
        .el-step__head {
          .el-step__icon.is-icon {
            background: #FFF;
          }
        }
      }
      &:last-child {
        .el-step__head {
          .el-step__icon.is-icon {
            background: #FFF;
          }
        }
      }
      .el-step__head {
        &.is-finish {
          .el-step__line {
            background: $color-text-primary;
          }
          .rhcn-dot {
            background-color: #0098C7;
          }
        }
        &.is-wait, &.is-process {
          .el-step__line {
            background: $color-default;
          }
        }
        &.is-wait {
          .el-step__icon.is-icon {
            width: 0;
          }
        }
      }
      .el-step__main {
        .el-step__title {
          font-size: 14px;
          font-weight: 800;
          line-height: 19px;
          color: $color-text-primary !important;
          position: relative;
          &.is-finish {
            color: #0098C7 !important;
          }
          .rhcn-step-title {
            position: absolute;
            transform: translateX(-40%);
            top: 8px;
            white-space: nowrap;
          }
          .rhcn-step-click-btn {
            display: inline-block;
            white-space: nowrap;
            background: transparent;
            height: 41px;
            position: absolute;
            top: -19px;
            transform: translateX(-40%);
            z-index: 9;
            color: transparent;
          }
        }
      }
    }
  }
}
</style>
